export var stockDetails = [
    {
        exc: "NSE",
        code: "20559",
        sym: "-29",
        dpCode: "Nifty 50",
        displayName: "Nifty 50",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "22113",
        sym: "-23",
        dpCode: "Nifty Next 50",
        displayName: "Nifty Next 50",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "27176",
        sym: "-25",
        dpCode: "Nifty 100",
        displayName: "Nifty 100",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "41356",
        sym: "-43",
        dpCode: "Nifty 200",
        displayName: "Nifty 200",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "22115",
        sym: "-44",
        dpCode: "Nifty 500",
        displayName: "Nifty 500",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "26771",
        sym: "-22",
        dpCode: "NIFTY MIDCAP 100",
        displayName: "Nifty Midcap 100",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "40939",
        sym: "-45",
        dpCode: "NIFTY SMLCAP 100",
        displayName: "Nifty Smallcap 100",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "42900",
        sym: "-49",
        dpCode: "NIFTY Alpha 50",
        displayName: "Nifty Alpha 50",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "28303",
        sym: "-24",
        dpCode: "Nifty Midcap 50",
        displayName: "Nifty Midcap 50",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "--",
        sym: "",
        dpCode: "F&O Stocks",
        displayName: "F&O Stocks",
        Index: "keyInd",
    },
    {
        exc: "BSE",
        code: "20558",
        sym: "-101",
        dpCode: "SENSEX",
        displayName: "Sensex",
        Index: "keyInd",
    },
    {
        exc: "BSE",
        code: "21558",
        sym: "-103",
        dpCode: "BSE100",
        displayName: "BSE 100",
        Index: "keyInd",
    },
    {
        exc: "BSE",
        code: "21559",
        sym: "-104",
        dpCode: "BSE200",
        displayName: "BSE 200",
        Index: "keyInd",
    },
    {
        exc: "BSE",
        code: "21552",
        sym: "-102",
        dpCode: "BSE500",
        displayName: "BSE 500",
        Index: "keyInd",
    },
    {
        exc: "BSE",
        code: "66493",
        sym: "-106",
        dpCode: "MIDCAP",
        displayName: "BSE Midcap",
        Index: "keyInd",
    },
    {
        exc: "BSE",
        code: "26568",
        sym: "-105",
        dpCode: "SMLCAP",
        displayName: "BSE Small-Cap",
        Index: "keyInd",
    },
    {
        exc: "NSE",
        code: "26753",
        sym: "-21",
        dpCode: "Bank Nifty",
        displayName: "Bank Nifty",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "41328",
        sym: "-46",
        dpCode: "Nifty Auto",
        displayName: "Nifty Auto",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "26768",
        sym: "-36",
        dpCode: "Nifty Energy",
        displayName: "Nifty Energy",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "41384",
        sym: "-40",
        dpCode: "Nifty Fin Service",
        displayName: "Nifty Fin Service",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "30183",
        sym: "-35",
        dpCode: "Nifty FMCG",
        displayName: "Nifty FMCG",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "24484",
        sym: "-28",
        dpCode: "Nifty IT",
        displayName: "Nifty IT",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "41359",
        sym: "-47",
        dpCode: "Nifty Media",
        displayName: "Nifty Media",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "41329",
        sym: "-48",
        dpCode: "Nifty Metal",
        displayName: "Nifty Metal",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "26769",
        sym: "-33",
        dpCode: "Nifty Pharma",
        displayName: "Nifty Pharma",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "28254",
        sym: "-31",
        dpCode: "Nifty PSU Bank",
        displayName: "Nifty PSU Bank",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "28253",
        sym: "-30",
        dpCode: "Nifty Realty",
        displayName: "Nifty Realty",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "75347",
        sym: "-53",
        dpCode: "NIFTY HEALTHCARE",
        displayName: "NIFTY HEALTHCARE",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "74741",
        sym: "-54",
        dpCode: "NIFTY CONSR DURBL",
        displayName: "Nifty Consumer Durables",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "74742",
        sym: "-55",
        dpCode: "NIFTY OIL AND GAS",
        displayName: "NIFTY OIL AND GAS",
        Index: "secInd",
    },
    {
        exc: "NSE",
        code: "67813",
        sym: "-56",
        dpCode: "Nifty Pvt Bank",
        displayName: "Nifty Private Bank",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "21554",
        sym: "-107",
        dpCode: "BSEFMC",
        displayName: "BSE FMCG",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "21557",
        sym: "-108",
        dpCode: "Not streaming",
        displayName: "",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "21557",
        sym: "-108",
        dpCode: "BSE HC",
        displayName: "BSE Healthcare",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "65968",
        sym: "-109",
        dpCode: "INDSTR",
        displayName: "BSE Industrials",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "21553",
        sym: "-110",
        dpCode: "BSE IT",
        displayName: "BSE IT",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "65969",
        sym: "-111",
        dpCode: "TELCOM",
        displayName: "BSE Telecom",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "25112",
        sym: "-112",
        dpCode: "AUTO",
        displayName: "BSE Auto",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "23998",
        sym: "-113",
        dpCode: "BANKEX",
        displayName: "BSE Bankex",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "21555",
        sym: "-114",
        dpCode: "BSE CG",
        displayName: "BSE Capital Goods",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "21556",
        sym: "-115",
        dpCode: "BSE CD",
        displayName: "BSE Consumer Durable",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "25113",
        sym: "-116",
        dpCode: "METAL",
        displayName: "BSE Metal",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "25114",
        sym: "-117",
        dpCode: "OILGAS",
        displayName: "BSE Oil& Gas",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "28435",
        sym: "-118",
        dpCode: "POWER",
        displayName: "BSE Power",
        Index: "secInd",
    },
    {
        exc: "BSE",
        code: "28155",
        sym: "-119",
        dpCode: "REALTY",
        displayName: "BSE Realty",
        Index: "secInd",
    },
];
export var nifty50 = stockDetails[0];
